import DatePickerView from '../date-picker-view/locale/ru_RU';
import DatePicker from '../date-picker/locale/ru_RU';
import InputItem from '../input-item/locale/ru_RU';
import Pagination from '../pagination/locale/ru_RU';
import Picker from '../picker/locale/ru_RU';
import SearchBar from '../search-bar/locale/ru_RU';
import Menu from '../menu/locale/ru_RU';
import PullToRefresh from '../pull-to-refresh/locale/ru_RU';
export default {
    locale: 'ru',
    Pagination,
    DatePicker,
    DatePickerView,
    InputItem,
    Picker,
    SearchBar,
    Menu,
    PullToRefresh,
};
